<template>
  <div class="skeleton" :class="type">
    <div class="skAnimation"></div>
    <div class="skeletonThumb" v-if="thumb === undefined || thumb === true">
      <div class="skThumbCnt">
        <div class="thumb"/>
        <div class="thumb2"/>
      </div>
      <div class="skThumbCnt">
        <div class="thumb"/>
        <div class="thumb2"/>
      </div>
      <div class="skThumbCnt">
        <div class="thumb"/>
        <div class="thumb2"/>
      </div>
      <div class="skThumbCnt">
        <div class="thumb"/>
        <div class="thumb2"/>
      </div>
      <div class="clear"/>
    </div>
    <div class="skeletonTab" v-if="tab === undefined || tab === true">
      <div class="skTabCnt skTabCnt1"/>
      <div class="skTabCnt"/>
      <div class="skTabCnt"/>
      <div class="clear"></div>
    </div>
    <div class="skeletonTable" v-if="table === undefined || table === true">
      <div class="skTblHeader" v-if="header === undefined || header === true">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
      <div class="skTblBody">
        <div :class="{skTh: true, skTh1: td1 === undefined || td1 === true}"/>
        <div class="skTh"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['thumb', 'header', 'tab', 'type', 'table', 'td1'],
};
</script>

<style lang="scss">
  .skeleton{
    margin: 0 -30px;
    position: relative;
    overflow: hidden;
    .skAnimation{
      position: absolute;
      top: -40px;
      bottom: -40px;
      left: -200px;
      width: 200px;
      // background-color: red;
      background-image: linear-gradient(to right, transparent,#fff,transparent);
      z-index: 1;
      animation: skAnimate 2.2s infinite;
      opacity: .8;
    }

    @keyframes skAnimate {
      from { left: -200px; }
      to { left: calc(100% + 200px); }
    }

    .skeletonThumb{
      border-bottom: #f5f5f5 1px solid;
      padding: 20px 30px 0;
      .skThumbCnt{
        display: block;
        float: left;
        margin-right: 60px;
        .thumb, .thumb2{
          width: 80px;
          height: 37px;
          background-color: #eee;
          border-radius: 5px;
          margin-bottom: 8px;
        }
        .thumb2{
          height: 16px;
          margin-bottom: 20px;
        }
      }
    }
    .skeletonTab{
      border-bottom: #f5f5f5 1px solid;
      .skTabCnt{
        width: 220px;
        position: relative;
        float: left;
        height: 49px;
      }
      .skTabCnt1:before{
        content: "";
        position: absolute;
        bottom: 0; left: 0; right: 0;
        height: 4px;
        background-color: #eee;
      }
      .skTabCnt:after{
        left: 30px;
        top: 12px;
        bottom: 12px;
        width: 90px;
        background-color: #eee;
        content: "";
        position: absolute;
      }
    }
    .skeletonTable{
      display: table;
      width: 100%;
      .skTh{
        border-bottom: #f5f5f5 1px solid;
        position: relative;
        display: table-cell;
      }
      .skTh1{
        width: 100px;
      }
      .skTh:before{
        position: absolute;
        content: "";
        top: 16px; left: 30px; bottom: 16px; right: 30px;
        background-color: #eee;
        border-radius: 5px;
      }
      .skTblHeader{
        height: 40px;
        display: table-row;
      }
      .skTblBody{
        height: 68px;
        border-bottom: #f5f5f5 1px solid;
        display: table-row;
      }
    }
    &.user{
      .skeletonTable{
        .skTblBody{
          .skTh{
            &.skTh1{
              width: 50px;
              &:before{
                border-radius: 50%;
                right: auto;
                width: 36px;
                bottom: auto;
                height: 36px;
              }
            }
          }
        }
      }
    }
    &.article{
      .skeletonTable{
        .skTblBody{
          .skTh{
            height: 179px;
            &:before{
              left: -12px;
            }
            &.skTh1{
              width: 180px;
              &:before{
                left: 30px;
              }
            }
          }
        }
      }
    }
  }
</style>
